// extracted by css-extract-rspack-plugin
export default {"symbol":"uUpv0"};